<template>
  <BaseRadioGroup v-model="value" class="flex flex-col">
    <BaseRadio
      v-for="item in options"
      :key="item.value"
      class="px-2 py-1 hover:bg-gray-100"
      :value="item.value"
    >
      <div class="w-full break-words whitespace-pre-wrap" style="line-height: 115%;">
        {{ item.label }}
      </div>
    </BaseRadio>
  </BaseRadioGroup>
</template>

<script lang="ts">
import { useVModel } from '@vueuse/core';
import { defineComponent, PropType } from 'vue';

import { OptionItem } from '@/models/option_item';

import BaseRadio from './BaseRadio.vue';
import BaseRadioGroup from './BaseRadioGroup.vue';

export default defineComponent({
  name: 'SurveyInputRadio',
  components: {
    BaseRadioGroup,
    BaseRadio,
  },
  props: {

    /**
     *  選択されている値のリスト
     */
    modelValue: {
      type: String,
      default: undefined,
    },

    /**
     *  選択肢のリスト
     */
    options: {
      type: Array as PropType<OptionItem[]>,
      default: () => [],
    },
  },
  emits: [
    'update:modelValue',
  ],
  setup(props, { emit }) {
    const value = useVModel(props, 'modelValue', emit);
    return {
      value,
    };
  },
});
</script>
